export default __webpack_public_path__ + "static/media/sass-doc.fcc82d4e.svg";